module.exports = __webpack_public_path__ + "img/7.497ccf0c.jpg";